
export const styles = ({ _palette, _components }) => ({

  root: {
  },
  inputField: {

  },
  adornment: {
    marginRight: 3,
  },
  reduceLeftMargin: {
    extend: 'adornment',
    paddingBottom: 2,
    marginLeft: 3,
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
});

